import React from 'react'
import styled from 'styled-components'

import { TextInput, Icon } from 'components'
import { TextInputProps } from 'components/TextInput'
import { copyTextToClipboard } from 'utils/clipboard'

const ClipBoardCopyInput: React.FC<TextInputProps> = (props) => (
  <ClipBoardCopyInputWrapper>
    <TextInput
      readOnly
      customIcon={
        <Icon
          onClick={() => {
            copyTextToClipboard(props.value as string)
          }}
          icon={['far', 'copy']}
          color="gray5"
        />
      }
      {...props}
    />
  </ClipBoardCopyInputWrapper>
)

const ClipBoardCopyInputWrapper = styled.div`
  input {
    border: 1px solid ${({ theme }) => theme.colors.gray4};
  }
`

export default ClipBoardCopyInput
